export default "__VITE_ASSET__Aq05elEx__"